import { NOTIFY_DANGER, NOTIFY_SUCCESS } from './action-types'
import { notify } from './notification-actions'
import { getText } from '../../internal/TextLabels'
import { request } from './auth-actions'
import { genericError } from './action-utils'

import MerchantOrderServiceApi from '../../api/merchant-order-service-api'

export const sendOrder = order => dispatch =>
  dispatch(request(MerchantOrderServiceApi.sendOrder(order)))
    .then(({ success }) =>
      success
        ? notify(NOTIFY_SUCCESS, getText('support.pages.order.success'))
        : notify(NOTIFY_DANGER, getText('support.pages.order.error')),
    )
    .catch(error => {
      genericError(error)
      throw error
    })
